import Vue from 'vue';
import axios from 'axios';
import Router from 'vue-router';
import Login from '@/app/Login';
import SearchView from '@/app/SearchView';
import SingleView from '@/app/SingleView';
import PageNotFound from '@/app/PageNotFound';
import Config from '../../static/conf.json';

window.axios = axios;

Vue.use(Router);

const portals = Object.keys(Config);
const index = portals.indexOf('default');
if (index > -1) {
  portals.splice(index, 1);
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:key',
      name: 'Search-view',
      component: SearchView,
      caseSensitive: false,
      meta: {
        search: true,
        requiresAuth: true,
      },
    },
    {
      path: '/:key/login',
      name: 'Login-portal',
      component: Login,
      caseSensitive: false,
      meta: { login: true },
    },
    {
      path: '/:key?/issue/:issuekey',
      name: 'Jira-ticket',
      component: SingleView,
      caseSensitive: false,
      meta: { jira: true },
    },
    {
      path: '/token/:token',
      name: 'Jira-ticket-token',
      component: SingleView,
      caseSensitive: false,
      meta: { token: true },
    },
    {
      path: '/:key?/page/:identifier',
      name: 'Confluence-page',
      component: SingleView,
      caseSensitive: false,
      meta: { confluence: true },
    },
    {
      path: '/login/:method/:targetKey',
      name: 'Login-issue',
      component: Login,
      caseSensitive: false,
      meta: { login: true },
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        noHeader: true,
      },
    },
  ],
  linkActiveClass: 'active',
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const routeKey = to.params.key.toLowerCase();
    const formData = new FormData();
    formData.append('portal', routeKey);

    const url = '/app/auth/session';
    axios({
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      data: formData,
    }).then(() => {
      next();
    }).catch((error) => {
      if (error.response.data.message === '> Keine Zugriffsrechte') {
        next(`/${routeKey}/login?perm=false`);
      } else if (error.response.data.message === '> Ungültiger Portalname') {
        next(`/?path=${routeKey}`);
      } else {
        next(`/${routeKey}/login`);
      }
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js